import React from "react";
import { Grid } from "@mui/material";
import { Alert, DateField, RadioField, TextField } from "@curves/ui-base";
import { LeaveTextField } from "@icoach/documents/components";
import { FieldGroup } from "@icoach/documents/components/Layout";
import { ReadTextField } from "@icoach/components";
import { displayDateText, parseDate } from "@util/moment";
import { getErrorModuleStatus, isEmpty, isEqual } from "@util/utils";
import { useMembershipSuspensionFormContext } from "@icoach/documents/membership/suspension/MembershipSuspensionFormContext";

const MembershipSuspensionSettingSection = () => {
	const {
		formData,
		formRef,
		options,
		validationErrors,
		isReadOnly,
		handleSuspendTypeChange,
		handleSuspendReasonChange,
		handleSuspendDataChange,
		handleSuspendMonthChange,
		handleSuspendDayChange,
	} = useMembershipSuspensionFormContext();

	const {
		suspendType,
		suspendReasonType,
		suspendReasonText,
		suspendStartDate,
		suspendEndDate,
		suspendMonth,
		suspendDay,
		isAllowSuspend,
		warningMessage,
	} = formData;
	const { suspendTypeOptions, suspendReasonTypeOptions } = options;

	const isShowDay = !isEqual(suspendType, 1);
	const showWarningMessage = !isAllowSuspend && !isEmpty(warningMessage);

	return (
		<FieldGroup label="暫停設定">
			<Grid item xs={12}>
				<Alert severity="info" variant="filled" color="info" className="alert-justify-content-start">
					我們邀請妳填寫以下資料，以協助妳完成後續的會員權暫停手續。
				</Alert>
			</Grid>

			<Grid item xs={12}>
				{!isEmpty(suspendTypeOptions) && (
					<RadioField
						label="暫停假別"
						value={suspendType}
						{...getErrorModuleStatus(validationErrors, "suspendType")}
						readOnly={isReadOnly}
						onChange={handleSuspendTypeChange}
						required
						row
					>
						{suspendTypeOptions.map(({ text, value }) => (
							<RadioField.Radio key={value} value={value} label={text} />
						))}
					</RadioField>
				)}
			</Grid>

			<Grid item xs={12}>
				{!isEmpty(suspendReasonTypeOptions) && (
					<RadioField
						label="暫停原因"
						value={suspendReasonType}
						{...getErrorModuleStatus(validationErrors, "suspendReasonType")}
						onChange={handleSuspendReasonChange}
						readOnly={isReadOnly}
						fullWidth
						required
						row
					>
						{suspendReasonTypeOptions.map(option => (
							<RadioField.Radio key={option.value} value={option.value} label={option.text} />
						))}
					</RadioField>
				)}
			</Grid>

			<Grid item xs={8}>
				<TextField
					label="原因說明(字數限字20字)"
					ref={el => (formRef.current.suspendReasonText = el)}
					defaultValue={suspendReasonText}
					{...getErrorModuleStatus(validationErrors, "suspendReasonText")}
					required={isEmpty(suspendReasonType, 9)}
					readOnly={isReadOnly}
					maxLength={20}
					rows={2}
					multiline
					fullWidth
				/>
			</Grid>

			<Grid item xs={4} />

			<Grid item xs={4}>
				<DateField
					label="暫停開始時間"
					ref={el => (formRef.current.suspendStartDate = el)}
					defaultValue={parseDate(suspendStartDate)}
					onChange={handleSuspendDataChange}
					{...getErrorModuleStatus(validationErrors, "suspendStartDate")}
					readOnly={isReadOnly}
				/>
			</Grid>

			<Grid item xs={5}>
				<LeaveTextField
					label="暫停多久"
					className="full-width"
					ref={el => (formRef.current.suspendDateLength = el)}
					isShowDay={isShowDay}
					dayProps={{
						type: "number",
						defaultValue: suspendDay,
						onChangeNative: handleSuspendDayChange,
						inputProps: {
							min: 0,
						},
						disabled: isReadOnly,
					}}
					monthProps={{
						type: "number",
						defaultValue: suspendMonth,
						onChangeNative: handleSuspendMonthChange,
						inputProps: {
							min: 0,
						},
						disabled: isReadOnly,
					}}
					{...getErrorModuleStatus(validationErrors, "suspendDay")}
					fullWidth
					readOnly={isReadOnly}
					required
				/>
			</Grid>

			<Grid item xs={8}>
				<ReadTextField label="暫停期間">{displayDateText(suspendStartDate, suspendEndDate)}</ReadTextField>
			</Grid>

			{showWarningMessage && (
				<Grid item xs={12}>
					<Alert severity="error" variant="filled" color="error" className="alert-justify-content-start">
						{warningMessage}
					</Alert>
				</Grid>
			)}
		</FieldGroup>
	);
};

export default MembershipSuspensionSettingSection;